import { ApexOptions } from 'apexcharts';

import { TFunction } from 'i18next';

interface ChartData {
  series: number[];
  labels: string[];
}

export const pieSnapActivationsChartOptions = (chartData: ChartData, t: TFunction, enter: string) => {
  const chartOptions: ApexOptions = {
    chart: {
      type: 'donut',
    },
    colors: ['#EED32E', '#6A37D4'],
    series: chartData.series || [],
    labels: chartData.labels || [],
    title: {
      text: enter === 'L' ? t('MCTDetail.activation_pies.title_1') : t('MCTDetail.activation_pies.title_2'),
      align: 'center',
      offsetY: -3,
      style: {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#000000',
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: '45%',
          labels: {
            show: false,
          },
        },
      },
    },
    tooltip: {
      enabled: true,
      fillSeriesColor: false,
      custom: ({ series, seriesIndex }: any) => {
        if (seriesIndex >= 0 && seriesIndex < chartData.labels.length) {
          const label = chartData.labels[seriesIndex];
          const value = series[seriesIndex];
          return `<div class="custom-tooltip">
            <div style="background: #ffffff; color: #333; padding: 8px 12px; border-radius: 6px; font-size: 12px; border: 2px solid #6A37D4;">
              ${label === 'Not caught' ? t('MCTDetail.activation_pies.not_caught') : t('MCTDetail.activation_pies.capture')}: ${value}
            </div>
          </div>`;
        }
        return '';
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: true,
      formatter: (_val: any, opts: any) => {
        const seriesIndex = opts.seriesIndex;

        if (seriesIndex < 0 || seriesIndex >= chartData.series.length) {
          return '';
        }

        const count = chartData.series[seriesIndex];
        if (typeof count === 'number' && seriesIndex === 0) {
          return [`${t('MCTDetail.activation_pies.not_caught')}`, `${count}`];
        } else if (typeof count === 'number' && seriesIndex === 1) {
          return [`${t('MCTDetail.activation_pies.capture')}`, `${count}`];
        }

        return '';
      },
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
      },
      dropShadow: {
        enabled: true,
        color: '#111',
        top: 0,
        left: 0,
        blur: 3,
        opacity: 0.7,
      },
    },
    fill: {
      type: 'gradient',
    },
    responsive: [
      {
        breakpoint: 636,
        options: {
          dataLabels: {
            enabled: false,
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: false,
                },
              },
            },
          },
        },
      },
    ],
  };

  return chartOptions;
};
